var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMatch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.563C0 7.26417 0 6.96534 0 6.66651C0.0117187 6.59718 0.027832 6.52882 0.0351562 6.45899C0.144531 5.38038 0.483887 4.38624 1.09619 3.48536C2.33643 1.66114 4.6167 0.764658 6.76465 1.27345C7.99658 1.56544 8.95996 2.27296 9.74951 3.23976C9.82519 3.33253 9.89795 3.42823 9.97168 3.52247C10.0034 3.4961 10.0151 3.48927 10.0229 3.4795C10.0874 3.39796 10.1489 3.31397 10.2153 3.23438C11.5781 1.59376 13.2935 0.830576 15.4243 1.24122C17.48 1.6377 18.8486 2.90382 19.5537 4.83985C20.3335 6.98048 20 9.01661 18.769 10.9175C18.0859 11.9722 17.2495 12.8999 16.3179 13.7315C14.4902 15.3618 12.6362 16.9614 10.7861 18.5664C10.2612 19.0215 9.67822 19.001 9.13135 18.5313C7.70752 17.3076 6.28271 16.085 4.86719 14.8516C3.67529 13.8135 2.51904 12.7383 1.56982 11.4644C0.952148 10.6353 0.456543 9.74122 0.209961 8.72901C0.117188 8.34522 0.0688476 7.95167 0 7.563Z",
    fill: "#AAABAB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatch);
export default __webpack_public_path__ + "static/media/match.53bfdb4e2c5ec7711f2763b925c3d207.svg";
export { ForwardRef as ReactComponent };